import PropTypes from 'prop-types';
import React from 'react';

import findIndex from 'lodash/findIndex';

import Tag from 'components/tags/Tag';
import { tagsDownloads } from 'constants/tags';
import getTagColors from 'utils/color/getTagColors';

const CompanyDownloadTags = ({ tags = [], testId = '' }) => (
  <div className="flex flex-wrap items-center">
    {tags.map((tag) => {
      const tagIndex = findIndex(tagsDownloads, (t) => t.id === tag.id);
      const [bgColor, textColor] = getTagColors(tagIndex, tag.name?.length);

      return (
        <Tag
          key={tag.name}
          bgColor={bgColor}
          textColor={textColor}
          data-test-id={`${testId}-${tag.name}`}
        >
          {tag.name}
        </Tag>
      );
    })}
  </div>
);

CompanyDownloadTags.propTypes = {
  tags: PropTypes.array,
  testId: PropTypes.string,
};

export default CompanyDownloadTags;
